import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "overlay", "bar"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this._onScroll = this._onScroll.bind(this)
    this._onKeydown = this._onKeydown.bind(this)
    window.addEventListener("scroll", this._onScroll, { passive: true })
    document.addEventListener("keydown", this._onKeydown)
    this._onScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this._onScroll)
    document.removeEventListener("keydown", this._onKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  toggle() {
    this.openValue = !this.openValue
  }

  open() {
    this.openValue = true
  }

  close() {
    this.openValue = false
  }

  openValueChanged() {
    const open = this.openValue
    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("translate-x-0", open)
      this.panelTarget.classList.toggle("-translate-x-full", !open)
      this.panelTarget.setAttribute("aria-hidden", String(!open))
      if (open) {
        this.panelTarget.removeAttribute("inert")
      } else {
        this.panelTarget.setAttribute("inert", "")
      }
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.toggle("hidden", !open)
    }
    document.body.classList.toggle("overflow-hidden", open)
  }

  _onKeydown(event) {
    if (event.key === "Escape" && this.openValue) this.close()
  }

  _onScroll() {
    if (!this.hasBarTarget) return
    const scrolled = window.scrollY > 8
    this.barTarget.classList.toggle("shadow-card", scrolled)
    this.barTarget.classList.toggle("bg-white", scrolled)
    this.barTarget.classList.toggle("dark:bg-canvas/95", scrolled)
  }
}
